import { FC } from 'react'
import PerText from '../../../../components/custom_components/Text'
import { TShirtSize } from '../../../../components/util/types'

interface Props {
  description: string
  mb?: TShirtSize
}

const AppraisalPageDescription: FC<Props> = ({ description, mb }) => {
  return (
    <PerText mb={mb || 'm'} color="secondary">
      {description}
    </PerText>
  )
}

export default AppraisalPageDescription
